export const comments_5689021 = {"data":{"data":[],"links":{}}}